import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersQuestionAnswerCategoriesIndexRequestType,
  ApiMembersBusinessSectionsQuestionAnswerCategoriesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersQuestionAnswerCategoriesIndexRequestType;
  businessSectionId: string;
  page?: number;
};

const request = async ({
  params,
  businessSectionId,
  page = 1,
}: RequestDataType): Promise<ApiMembersBusinessSectionsQuestionAnswerCategoriesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersBusinessSectionsQuestionAnswerCategoriesIndexResponseType>(
      `/api/members/business_sections/${businessSectionId}/question_answer_categories`,
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  params?: ApiMembersQuestionAnswerCategoriesIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersBusinessSectionsQuestionAnswerCategoriesIndex = ({
  businessSectionId,
  params,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersBusinessSectionsQuestionAnswerCategoriesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    [
      "ApisMembersBusinessSectionsQuestionAnswerCategoriesIndex",
      businessSectionId,
      params,
    ],
    ({ pageParam }) => {
      return request({
        businessSectionId,
        params,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
